import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'unico-people-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.removeAttribute('ng-version');
  }
}
